// eslint-disable-next-line import/prefer-default-export
export enum SupportedCRM {
  MSCRM = "MSCRM",
  ClickCRM = "ClickCRM",
}
